(function(){
  var root = document.querySelector('.af[data-af]');
  var cfgEl = document.querySelector('[data-af-config]');
  if (!root || !cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  var giftId = CFG.gift;
  var addonIds = CFG.addons;
  var fmt = function(c){ return (c/100).toLocaleString('fr-FR',{style:'currency',currency:CFG.cur}); };
  var $ = function(s,el){ return (el||root).querySelector(s); };
  var $$ = function(s,el){ return Array.prototype.slice.call((el||root).querySelectorAll(s)); };

  var cd = $('.af-count'); var end = new Date(cd.getAttribute('data-deadline')).getTime();
  function tick(){ var d = Math.max(0, end - Date.now()); var pad=function(n){return (n<10?'0':'')+n};
    $('[data-d]',cd).textContent = pad(Math.floor(d/864e5)); $('[data-h]',cd).textContent = pad(Math.floor(d/36e5)%24);
    $('[data-m]',cd).textContent = pad(Math.floor(d/6e4)%60); $('[data-s]',cd).textContent = pad(Math.floor(d/1e3)%60); }
  if (!isNaN(end)) { tick(); setInterval(tick, 1000); }

  var track = $('[data-track]'), thumbs = $$('[data-thumb]'), dots = $$('.af-gal__dots i');
  function setOn(i){ thumbs.forEach(function(t,k){t.classList.toggle('is-on',k===i)}); dots.forEach(function(t,k){t.classList.toggle('is-on',k===i)}); }
  thumbs.forEach(function(b,i){ b.addEventListener('click', function(){ track.scrollTo({left: track.clientWidth*i, behavior:'smooth'}); setOn(i); }); });
  if (track) track.addEventListener('scroll', function(){ setOn(Math.round(track.scrollLeft/track.clientWidth)); }, {passive:true});

  var packs = $$('[data-pack]'), adds = $$('[data-add]');
  function current(){ return $('[data-pack] input:checked'); }
  function update(){
    var r = current(); var total = parseInt(r.getAttribute('data-price'),10);
    packs.forEach(function(l){ l.classList.toggle('is-on', l.querySelector('input').checked); });
    adds.forEach(function(l){ var c=l.querySelector('input'); l.classList.toggle('is-on', c.checked); if(c.checked) total += parseInt(c.getAttribute('data-price'),10); });
    var pr=$('.af-price'); if(pr){ var up=parseInt(r.getAttribute('data-price'),10), cp=up+(CFG.compare[r.value]||0), u=pr.querySelector('[data-unit]'), sx=pr.querySelector('s');
      if(u) u.textContent=fmt(up);
      if(cp>up){ if(!sx){ sx=document.createElement('s'); pr.appendChild(sx); } sx.textContent=fmt(cp); sx.hidden=false; } else if(sx){ sx.hidden=true; } }
    $('[data-total]').textContent = fmt(total);
    var st=$('[data-sticky-total]'); if(st) st.textContent = fmt(total);
  }
  packs.forEach(function(l){ l.querySelector('input').addEventListener('change', update); });
  adds.forEach(function(l){ l.querySelector('input').addEventListener('change', update); });
  update();

  function addBiz(d,n){ d=new Date(d); while(n>0){ d.setDate(d.getDate()+1); var w=d.getDay(); if(w!==0&&w!==6) n--; } return d; }
  var o={day:'numeric',month:'long'}; var a=addBiz(new Date(),CFG.etaMin), b=addBiz(new Date(),CFG.etaMax);
  var eta = $('[data-eta]'); if (eta) eta.textContent = 'entre le ' + a.toLocaleDateString('fr-FR',o) + ' et le ' + b.toLocaleDateString('fr-FR',o);

  var drawer=$('[data-drawer]'), ov=$('[data-ov]');
  function openCart(ok){ $('[data-ok]').hidden = !ok; drawer.classList.add('is-on'); ov.classList.add('is-on'); document.documentElement.style.overflow='hidden'; }
  function closeCart(){ drawer.classList.remove('is-on'); ov.classList.remove('is-on'); document.documentElement.style.overflow=''; }
  $$('[data-open-cart]').forEach(function(b){ b.addEventListener('click', function(){ render().then(function(){ openCart(false); }); }); });
  $$('[data-close-cart]').forEach(function(b){ b.addEventListener('click', closeCart); }); ov.addEventListener('click', closeCart);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeCart(); });

  function esc(t){ var d=document.createElement('div'); d.textContent=t||''; return d.innerHTML; }
  function render(){
    return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){
      $$('[data-count]').forEach(function(e){ e.textContent = c.item_count; });
      var box=$('[data-items]'); box.innerHTML='';
      var saved=0;
      if(!c.items.length){ box.innerHTML='<p class="af-empty">Ton panier est vide.</p>'; }
      c.items.forEach(function(it){
        var el=document.createElement('div'); el.className='af-line';
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2') : '';
        var isGift = it.variant_id===giftId;
        el.innerHTML = (img?'<img src="'+img+'" alt="">':'<img alt="">') +
          '<div><b>'+esc(it.product_title)+'</b><small>'+(it.variant_title && it.variant_title!=='Default Title' ? esc(it.variant_title)+' · ' : '')+'Qté '+it.quantity+'</small>'+
          (isGift?'':'<br><button type="button" data-rm="'+it.key+'">Retirer</button>')+'</div>'+
          '<p>'+(isGift?'<s>'+esc(CFG.giftValue)+'</s>OFFERT':fmt(it.final_line_price))+'</p>';
        box.appendChild(el);
      });
      c.items.forEach(function(it){ var d=CFG.compare[it.variant_id]; if(d) saved += d*it.quantity; });
      $('[data-saved-row]').hidden = !saved; $('[data-saved]').textContent = '−'+fmt(saved);
      $('[data-sub]').textContent = fmt(c.items_subtotal_price); $('[data-ctotal]').textContent = fmt(c.total_price);
      $$('[data-rm]',box).forEach(function(b){ b.addEventListener('click', function(){
        fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:b.getAttribute('data-rm'),quantity:0})})
          .then(function(){ return fetch('/cart.js').then(function(r){return r.json()}); })
          .then(function(c2){ var main = c2.items.filter(function(i){ return i.variant_id!==giftId && addonIds.indexOf(i.variant_id)===-1; });
            if(!main.length && c2.items.length){ return fetch('/cart/clear.js',{method:'POST'}); } })
          .then(render);
      }); });
      return c;
    });
  }

  function addToCart(){
    var items=[{id: parseInt(current().value,10), quantity:1}];
    adds.forEach(function(l){ var c=l.querySelector('input'); if(c.checked) items.push({id: parseInt(c.value,10), quantity:1}); });
    return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      var ids = c.items.map(function(i){return i.variant_id});
      items = items.filter(function(it){ return addonIds.indexOf(it.id)===-1 || ids.indexOf(it.id)===-1; });
      if (giftId && ids.indexOf(giftId)===-1) items.push({id: giftId, quantity:1});
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})});
    }).then(function(r){ if(!r.ok) throw r; return r.json(); });
  }
  $$('[data-atc]').forEach(function(b){ b.addEventListener('click', function(){
    var t=b.textContent; b.disabled=true; b.textContent='Ajout…';
    addToCart().then(render).then(function(){ openCart(true); }).catch(function(e){ console.error('[avent] ATC', e); t='Erreur, réessaie'; }).finally(function(){ b.disabled=false; b.textContent=t; });
  }); });
  var bn=$('[data-buynow]'); if(bn) bn.addEventListener('click', function(){ bn.disabled=true; addToCart().then(function(){ window.location.href='/checkout'; }).catch(function(){ bn.disabled=false; }); });

  var sticky=$('[data-sticky]'), buy=$('#af-buy');
  if('IntersectionObserver' in window){
    if(sticky && buy) new IntersectionObserver(function(e){ sticky.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); },{threshold:0}).observe(buy);
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} }); },{threshold:.12});
    $$('.rv').forEach(function(el){ io.observe(el); });
  } else { $$('.rv').forEach(function(el){ el.classList.add('in'); }); }
  $$('[data-scrollbuy]').forEach(function(a){ a.addEventListener('click', function(e){ e.preventDefault(); buy.scrollIntoView({behavior:'smooth',block:'center'}); }); });
})();